import { Role } from '@/core/components/auth/auth.types'
import { LoadingList } from '@/core/components/LoadingList'
import { organizationByIdQueryOptions } from '@/core/components/organizations/organizationQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/organizations/$organizationId/edit/'
)({
  beforeLoad: ({ context: { auth }, location }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
        search: { redirect: location.href },
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger'] ||
      auth.user?.role === Role.PropertyManager
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { organizationId } }) =>
    queryClient.ensureQueryData(
      organizationByIdQueryOptions(organizationId, auth.token!)
    ),
  pendingComponent: LoadingList,
})
